import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { isJSDocThisTag } from 'typescript';
import { CandidateService } from '../_services/candidate.service';
import { LocalStorageService } from '../_services/local-storage.service';
import { TalentpoolService } from '../_services/talentpool.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-talnepool-candidate-tabs',
  templateUrl: './talnepool-candidate-tabs.component.html',
  styleUrls: ['./talnepool-candidate-tabs.component.scss']
})
export class TalnepoolCandidateTabsComponent implements OnInit {

  tabactive: string
  /**
   * My Talentpools count
  */
  myTalentpoolCounts: any
  /**
   * All Candidate count
  */
  allCandidateCounts: any
  /**
    * Shared Talentpool count
  */
  sharedTalentpoolCounts: number = 0;
  appliedFilters: any = {};
  private routerSubscription: Subscription;

  constructor(private router: Router, private localstorageservice: LocalStorageService, private candidateservice: CandidateService, private talentpoolservice: TalentpoolService) { }

  ngOnInit() {
    this.tabactive = this.router.url.split('/')[2]
    this.getTalentpoolList()
    this.getSharedTalentpoolsList();
    /**
     * Get talent pool data from observable
     * Set data in unfilter variables if filter is not applied
     */
    this.talentpoolservice.talentPoolCount.subscribe((talentPoolData) => {
      if(typeof talentPoolData == 'object' && Object.keys(talentPoolData).length) {
        this.myTalentpoolCounts = talentPoolData.talentpools.length;
        this.allCandidateCounts = talentPoolData.allcandidatescount;
      }
    });
    /**
     * Get shared talent pool data from observable
     * Set data in unfilter variables if filter is not applied
     */
    this.talentpoolservice.sharedTalentPoolDetails.subscribe((sharedTalentPoolData) => {
      this.sharedTalentpoolCounts = sharedTalentPoolData ? sharedTalentPoolData.count : 0;
    });
    /**
     * Get all candidate data from observable
     * Set data in unfilter variables if filter is not applied
     */
    this.talentpoolservice.allCandidateDetails.subscribe((allCandidateDetails) => {
      this.allCandidateCounts = allCandidateDetails ? allCandidateDetails.allcandidatescount : 0;
    });

    this.routerSubscription  = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const talentPoolData = this.localstorageservice.getItem('talentPoolDetails') ? JSON.parse(this.localstorageservice.getItem('talentPoolDetails')) : null;
        const sharedTalentPoolData = this.localstorageservice.getItem('sharedTalentPoolDetails') ? JSON.parse(this.localstorageservice.getItem('sharedTalentPoolDetails')) : null;

        this.myTalentpoolCounts = talentPoolData ? talentPoolData.talentpools.length : 0;
        this.sharedTalentpoolCounts = sharedTalentPoolData ? sharedTalentPoolData.count : 0;
        this.allCandidateCounts = talentPoolData ? talentPoolData.allcandidatescount : 0;
      }
    });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  gettalentpoolcounts(event) {
    this.myTalentpoolCounts = event
  }

  /**
   * Receive event from component to refresh counts
   * @param event 
   */
  getSharedTalentpoolsCounts(event: number) {
    this.sharedTalentpoolCounts = event;
  }

  onTabChange(type) {
    if(type == 'talentpool') {
      this.tabactive = 'talentpool'
      this.router.navigateByUrl('/talent/talentpool')
    } else if(type == 'candidate-list') {
      this.tabactive = 'candidate-list'
      this.appliedFilters = {};
     // this.getcandidatescounts()
      this.router.navigate(['/talent/candidate-list'])
    } else if(type === 'shared-talentpool') {
      this.tabactive = 'shared-talentpool'
      this.appliedFilters = {};
      this.router.navigateByUrl('/talent/shared-talentpool')
    }
  }

  getcandidatescounts() {
    let paylod = {
        startingfrom: 0,
        usernumber: this.localstorageservice.getItem('usernumber'),
        sortby: 'new' ,
        ...this.appliedFilters,
        pipelinestatus: "'Hot', 'Warm', 'Cold'",
        fetchonlycountdetails: true
    }
    this.candidateservice.getCandidateList(paylod).subscribe((res:any)=>{
      this.allCandidateCounts = res.data.candidatenumbers.length

    })
  }

  getTalentpoolList(){
    this.talentpoolservice.getTalentpoolList(this.localstorageservice.getItem('usernumber')).subscribe((res:any)=>{
      if(res.status =="success"){
        this.myTalentpoolCounts = res.data.talentpools.length;
        this.allCandidateCounts = res.data.allcandidatescount;
        this.localstorageservice.setItem('talentPoolDetails', JSON.stringify(res?.data) || null);
        this.talentpoolservice.setTalentPoolDetails(res?.data || null);
      }
      
    })

  }

  /**
   * Get shared talentpools listing (for count)
   */
  getSharedTalentpoolsList(){
    this.talentpoolservice.getSharedTalentpoolsList(this.localstorageservice.getItem('usernumber')).subscribe((res:any)=>{
      if(res.status =="success") {
        this.sharedTalentpoolCounts = res?.data?.talentpools?.length || 0;
        this.localstorageservice.setItem('sharedTalentPoolDetails', JSON.stringify(res?.data) || null);
        this.talentpoolservice.setSharedTalentPoolDetails(res?.data || null);
      }
    }, ()=>{
      this.sharedTalentpoolCounts = 0;
      this.localstorageservice.setItem('sharedTalentPoolDetails', null);
      this.talentpoolservice.setSharedTalentPoolDetails(null);
    });
  }

  getcandidatelistrefresh(event) {
    this.appliedFilters = event
   // console.log(event)
    this.getcandidatescounts()
  }

}
